export const ValidationErrorsMSG = {
    1: 'Benyt Wildcard (W) på en kamp for at placere spil. Wildcard er en gratis helgardering.',
    2: 'Du kan ikke købe din kupon, før du har sat tegn ud for hver kamp (1X2 og over/under) eller brugt dit Wildcard. Minimumsindsats for Big 9 er 8 kr.',
};

export const calculateRows = (outcomes = {}, formattingMarks = () => {}) => {
    const marksExist = Object.keys(outcomes).some((key) => {
        return outcomes[key].marks.length;
    });

    return marksExist
        ? Object.keys(outcomes).reduce((acc, key) => {
              // [ ['1', '2', 'X'], ['O', 'U'], ['*'] ]
              let splitArray = [[], [], []];
              const result =
                  acc *
                  outcomes[key].marks.reduce((result, item) => {
                      if (item !== '') {
                          if (item === 'O' || item === 'U') {
                              splitArray[1].push(item);
                          } else if (item !== '*') {
                              splitArray[0].push(item);
                          } else {
                              splitArray[2].push(item);
                          }
                      }

                      return (
                          splitArray[2].length ||
                          (splitArray[0].length || 1) *
                              (splitArray[1].length || 1)
                      );
                  }, 1);
              formattingMarks({ [key]: splitArray });
              return result;
          }, 1)
        : 0;
};

export const prepareValidationField = (marks) => {
    let validatedFields = {};
    Object.keys(marks).forEach((key) => {
        validatedFields = {
            ...validatedFields,
            [key]: [
                !!marks[key][0].length ||
                    !!marks[key][2].length ||
                    marks[key][0].includes('canceled'),
                !!marks[key][1].length ||
                    !!marks[key][2].length ||
                    marks[key][0].includes('canceled'),
            ],
        };
    });
    return validatedFields;
};

export const couponValidation = (marks, wildcard, combinationPrice) => {
    const validatedFields = prepareValidationField(marks);
    const itemsKeys = Object.keys(validatedFields);
    if (
        itemsKeys.some((key) => validatedFields[key].some((mark) => !mark)) ||
        itemsKeys.length < 9 ||
        combinationPrice < 8
    ) {
        return {
            status: false,
            message: ValidationErrorsMSG[2],
        };
    } else if (!wildcard) {
        return {
            success: false,
            message: ValidationErrorsMSG[1],
        };
    } else {
        return {
            status: true,
            message: '',
        };
    }
};
